import { render } from "./EachRestaurantMenu.vue?vue&type=template&id=94ed7ada&scoped=true"
import script from "./EachRestaurantMenu.vue?vue&type=script&lang=js"
export * from "./EachRestaurantMenu.vue?vue&type=script&lang=js"

import "./EachRestaurantMenu.vue?vue&type=style&index=0&id=94ed7ada&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ed7ada"]])

export default __exports__